import { render, staticRenderFns } from "./images.vue?vue&type=template&id=ba2eee12&scoped=true"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2eee12",
  null
  
)

export default component.exports